export const pub = (path) => `${process.env.PUBLIC_URL}/${path}`;